import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private readonly env: 'development' | 'production' | 'test';

  constructor() {
    // Detectar entorno actual
    this.env = this.detectEnvironment();
    
    // Debug: mostrar información de configuración
    console.log('🔍 EnvironmentService initialized:', {
      detectedEnv: this.env,
      hostname: window.location.hostname,
      production: environment.production,
      secretKeyAvailable: !!this.getSecretKey()
    });
  }

  private detectEnvironment(): 'development' | 'production' | 'test' {
    if (environment.production) {
      return 'production';
    }
    
    // Detectar por URL
    const hostname = window.location.hostname;
    if (hostname.includes('test') || hostname.includes('staging')) {
      return 'test';
    }
    
    return 'development';
  }

  getSecretKey(): string {
    const env = this.env;
    
    // Obtener clave del archivo environment correspondiente
    const storageKey = (environment as any).storageSecretKey;
    
    if (storageKey && storageKey.trim() !== '') {
      console.log(`✅ Using ${env} key from environment.ts`);
      return storageKey.trim();
    }
    
    // Fallback si no hay clave configurada
    console.warn(`⚠️ Using fallback key for ${env}. Configure storageSecretKey in environment.ts!`);
    return this.getFallbackKey(env);
  }

  private getFallbackKey(env: string): string {
    // Claves de fallback (solo para desarrollo local)
    const fallbacks = {
      development: 'dev-fallback-key-insecure',
      test: 'test-fallback-key-insecure',
      production: 'prod-fallback-key-insecure'
    };
    
    return (fallbacks as any)[env] || fallbacks.development;
  }

  getEnvironment(): string {
    return this.env;
  }

  isProduction(): boolean {
    return this.env === 'production';
  }

  isDevelopment(): boolean {
    return this.env === 'development';
  }

  // Método para configurar claves en desarrollo (solo para testing)
  setDevelopmentKey(env: 'development' | 'test' | 'production', key: string): void {
    if (this.isDevelopment()) {
      const localStorageKey = `__dev_secret_${env}__`;
      localStorage.setItem(localStorageKey, key);
      console.log(`🔧 Development key set for ${env}`);
    } else {
      console.warn('⚠️ Development keys can only be set in development environment');
    }
  }
}
